import ButtonSelector from '../ButtonSelector';
import {ReactComponent as SearchIcon} from "assets/icons/search.svg";
import useWindowDimensions from 'helpers/screen';
import './style.scss'

const MarketsTop = ({title, filters = null, actionTitle=null, status=null}) => {

  const {width} = useWindowDimensions();
  return <div className="marketsTop">
    <div className="side">
      <div className='left'>
        <p className="title">
          {title}
        </p>
        {actionTitle &&
          <div className='actionButton'>
            {actionTitle}
          </div>
        }
      </div>
      {filters && <ButtonSelector items={filters} selected={0}/>}
    </div>
    {status ? 
    <p className='status'>{status}</p>
    :
    <div className="searchBar">
      <SearchIcon stroke="var(--gray500)"/>
      <input className="search" placeholder={ width <= 900 ? "Search":"Search by name, symbol or market address"}/>
    </div>
    }
  </div>
}

export default MarketsTop;